<template>
</template>

<script>
import Title from '@/components/Title'
import axios from 'axios'
import config from '@/config'

export default {
    name:"PaymentSummary",
    data: () => {
        return {
            refno: "",
            loading: false,
            fpxPayment: [],
            fpxPaymentStatus: false,
            transactionDate: "",
        }
    },
    mounted: function () {
        var win = window.open('http://www.yahoo.com','_self');
        setTimeout(function() { win.close();}, 3000);
    },
    components:{
        Title
    }
}
</script>